import script from "./header-search.vue?vue&type=script&lang=ts&setup=true"
export * from "./header-search.vue?vue&type=script&lang=ts&setup=true"

import "./header-search.vue?vue&type=style&index=0&id=64c967c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64c967c1"]])

export default __exports__